import { render } from "./SlipListPanel.vue?vue&type=template&id=19682041"
import script from "./SlipListPanel.vue?vue&type=script&lang=js"
export * from "./SlipListPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__